export const REST_SUBSCRIPTIONS = '/rest/subscriptions/';
export const REST_SUBSCRIPTIONS_ITEMS = '/items/';
export const REST_SUBSCRIPTIONS_PORTAL = '/payment/portal/';
export const REST_CHECK_SUBSCRIPTION_MANAGER_ENABLE_REPORT = '/rest/userActivityStat/subscriptionManagers/checkEnableReport/';
